import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateFormatPipe } from 'src/app/pipes/dateFormat.pipe';
import { MatPaginator } from '@angular/material/paginator';
import { UserService } from 'src/app/services/user.service';
@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.css']
})
export class ViewUserComponent implements OnInit {
  id: any;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  user: any;
  constructor(private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private datepipe: DateFormatPipe) { }
  ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
          this.id = params['id'];
          this.userService.getUserById(this.id)
            .subscribe(
              res => {
                this.user = res;
                console.log(this.user);
              }
            );
        });
      }
      goBacktoList() {
        this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
      }
      getCorrectDateAndTimeFormat(dateVal) {
        return this.datepipe.simpledateFormatWithTime(dateVal);
      }
}

